export const emailIconsKeys = {
  all: () => ['email-icons'] as const,
};
